var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundGridColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1432,
    height: 312,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "background-grid-color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2702",
    transform: "translate(-12094 -5761)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h1432v312H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 2",
    transform: "translate(12094 5761)",
    clipPath: "url(#background-grid-color_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7265"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9235",
    d: "M-12097.693-5607.778l126.4-82.448 98.055 199.235z",
    fill: "#76307f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9236",
    d: "M-11874.537-5490.671l224.273-46.436-189.9-83.559",
    fill: "#953a87"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9239",
    d: "M-12083.589-5447.951l209.639-43.429-223.743-116.554v159.983z",
    fill: "#562e7f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9240",
    d: "M-11578.867-5447.951l-295.352-43.482-224.438 43.482z",
    fill: "#563381"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9241",
    d: "M-11971.298-5690.217l132.945 70.564-35.854 128.218z",
    fill: "#923682"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9242",
    d: "M-12097.693-5675.058l-1.306 68.291 127.694-83.448z",
    fill: "#7e307f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9243",
    d: "M-11526.381-5523.784l29.146-54.024-153.838 40.516z",
    fill: "#9a4f90"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9244",
    d: "M-11497.235-5577.812l-29.861 54.672 177.043 40.138z",
    fill: "#985594"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9245",
    d: "M-11537.279-5447.951l11.275-76.056-124.89-13.344 124.043 100.93",
    fill: "#7e4088"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9246",
    d: "M-11551.016-5440.672l201.944-42.2-177.543-41.168-14.692 99.951",
    fill: "#79428a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9249",
    d: "M-11062.393-5512.325l154.679-35.993 95.7 122.013z",
    fill: "#5062a4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9250",
    d: "M-11029.773-5669.359s-22.593 115.895-29.895 155.173-.407 2.188-.407 2.188l152.438-36.1z",
    fill: "#7288bf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9252",
    d: "M-10907.636-5548.319l77.6 108.493 117.5-94.405z",
    fill: "#4271b1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9253",
    d: "M-10912.053-5631.995l4.328 83.91 194.913 14.28z",
    fill: "#4b84c0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9254",
    d: "M-11185.92-5612.294l-29.012 48.473-69.479-82.087z",
    fill: "#ad93bf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9255",
    d: "M-11127.378-5613.194l67.614 101.133-92.269-11.968-.048-75.885z",
    fill: "#887eb5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9256",
    d: "M-11215.111-5564.208l28.472-48.348 34.607 12.7 2.2 78.382z",
    fill: "#9480b3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9238",
    d: "M-11650.862-5537.352l122.828 98.021-347.2-52.061z",
    fill: "#763984"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9257",
    d: "M-11219.045-5445.611l-132.717-37.666 136.67-80.974-3.953 128.227",
    fill: "#7b5395"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9237",
    d: "M-11351.752-5483.292l136.66-80.953-69.336-81.671z",
    fill: "#9c6fa6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9258",
    d: "M-11225.193-5441.232l75.578-82.73-65.511-40.288-5.254 126.195",
    fill: "#745496"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9259",
    d: "M-11388.003-5564.961l36.15 81.369-145.314-94.16z",
    fill: "#a05f9b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9260",
    d: "M-11284.411-5645.907l-103.961 80.69 36.661 82.03z",
    fill: "#a66fa4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9261",
    d: "M-10922.298-5635.299l-107.457-34.037 122.231 121.572-4.569-84.255z",
    fill: "#6796ca"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9262",
    d: "M-10657.693-5640.656l-255.164 8.552 199.817 98.3 60.912-110.558",
    fill: "#4798d1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9263",
    d: "M-10827.786-5441.749l114.784-92.153 62.734 95.161z",
    fill: "#3362a0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9264",
    d: "M-10657.693-5635.82l-55.339 101.959 65.574 102.121z",
    fill: "#3985c0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9248",
    d: "M-11149.915-5524.154l90.294 12.056-171.139 74.862z",
    fill: "#664b92"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9266",
    d: "M-11099.445-5630.343l-28.048 17.187 67.711 101.111 30.011-157.291z",
    fill: "#9094c4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9267",
    d: "M-11227.815-5441.526l167.991-70.612 199.986 66.733z",
    fill: "#55468e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9247",
    d: "M-11221.323-5447.831l-130.2-35.467-191.766 39.957z",
    fill: "#653a86"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9268",
    d: "M-10727.974-5696.604l80.929-28.4-9.622 85.456z",
    fill: "#53b1e3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9269",
    d: "M-10912.829-5631.995l264.6-8.728-79.625-56.036-184.977 64.763",
    fill: "#57acdf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGridColor);
export default __webpack_public_path__ + "static/media/background-grid-color.c6984929303d41a33c5e4b0711ff6d44.svg";
export { ForwardRef as ReactComponent };